<template>
<transition name="rightin">
    <div class="change-card">
        <div class="card-nav">
            <a class="back-a" @click="back">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </a>
            <div class="right-items">
              <a>
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </a>
              <a class="share-a">
                <i class="fa fa-share-square-o" aria-hidden="true"></i>              </a>
            </div>
        </div>
        <div class="container">
          <span class="create-time">您创建于2017年4月20号 16:57</span>
          <span class="create-location">广顺北路 长宁区</span>
          <div class="input-bar">
            <div class="bar-inner">
              <input type="text" placeholder="标题">
            </div>
          </div>
          <div class="edit-text" contenteditable>
            我在测试
          </div>
          <div class="edit-text" contenteditable>
            手都酸了达芙妮色地方
          </div>
          <div class="div-image">
            <img src="../assets/image.png">
          </div>
          <a class="add-tag">
            <i class="fa fa-plus" aria-hidden="true"></i>
            <span>添加标签</span>
          </a>
        </div>
        <foot-bar></foot-bar>
    </div>
</transition>
</template>

<script>
import FootBar from '@/components/footBar'

export default {
  data () {
    return {}
  },
  methods: {
    back () {
      this.$router.back()
    }
  },
  components: {
    FootBar
  }
}
</script>

<style scoped>
.div-image img{
  width: 100%;
  height: 100%;
}
.div-image{
  width: 90%;
  align-self: center;
  min-height: 120px;
  max-height: 400px;
  background-color: rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  border-radius: 4px;
  overflow: hidden;
}
.add-tag{
  margin-left: 14px;
  margin-top: 20px;
 background-color: rgba(116, 177, 188, 1);
 padding: 2px 8px;
 border-radius: 10px;
 font-size: 14px;
}
.edit-text{
  width: 90%;
  appearance: textfield;
  background-color: white;
  align-self: center;
  margin-top: 10px;
  min-height: 120px;
  font-size: 17px;
  color: black;
  text-align: left;
  outline: none;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.bar-inner{
  background-color: rgba(106, 166, 177, 0.6);
  flex: auto;
  display: flex;
  padding: 0 10px;
  border-radius: 4px;
}
.bar-inner input{
  flex: auto;
  outline: none;
  border: none;
  background-color: transparent;
  color: white;
  font-size: 16px;
}
.input-bar{
  box-sizing: border-box;
  height: 40px;
  display: flex;
  padding: 0 10px;
  width: 100%;
  display: flex;
  margin-top: 4px;
}
.create-location{
 margin-top: 4px;
}
.create-time,
.create-location{
  font-size: 13px;
  padding-left: 10px;
}
.share-a{
  padding-top: 2px;
}
.right-items{
  font-size: 24px;
  display: flex;
  align-items: center;
}
.right-items a{
  margin-left: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-a{
  font-size: 24px;
}
.card-nav{
  height: 64px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  box-sizing: border-box;
  flex-shrink: 0;
}
.rightin-enter-active, 
.rightin-leave-active,
.rightin-leave {
}

.rightin-enter-active {
    transform: translate(0)
}

.rightin-enter, 
.rightin-leave-active {
  transform: translate(100%)
}
.container *{
  flex-shrink: 0;
}
.container{
    width: inherit;
    display: flex;
    color: white;
    flex-direction: column;
    align-items: flex-start;
    overflow: auto;
    padding-bottom: 20px;
    flex: auto;

    box-sizing: border-box;
    background: linear-gradient(to bottom left, #66d0a3 , #6aa6b1);
}
.change-card{
    width: 100%;
    height: 100%;
    background-color: transparent;
    transition: all 0.25s;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// updateCard.vue?154524fe